import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const getFamilyFestEventPageContent = (request) => vdkEmHappinessPortalApi.post('family-fest/event-page/get-by-language', request);
const updateFamilyFestEventPageContent = (request) => vdkEmHappinessPortalApi.put('family-fest/event-page/update', request);
const uploadFamilyFestEventPageImage = ({ eventId, languageId, fieldKey, file }) => {
    const formData = new FormData();
    formData.append('EventId', eventId);
    formData.append('LanguageId', languageId);
    formData.append('FieldKey', fieldKey);
    formData.append('File', file);
    return vdkEmHappinessPortalApi.post('family-fest/event-page/upload-image', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};
const removeFamilyFestEventPageImage = (request) => vdkEmHappinessPortalApi.delete('family-fest/event-page/remove-image', { data: request });
const applyFamilyFestEventPageTranslation = (request) => vdkEmHappinessPortalApi.post('family-fest/event-page/apply-translation-to-all', request);
const familyFestEventPageApi = {
    getFamilyFestEventPageContent,
    updateFamilyFestEventPageContent,
    uploadFamilyFestEventPageImage,
    removeFamilyFestEventPageImage,
    applyFamilyFestEventPageTranslation
};
export default familyFestEventPageApi;
